import React from 'react';
import { Grid, GridItem, TextButton, Typography } from 'seagull';
import { usePaymentMethodLearnMoreModal } from "../../../components/PaymentMethodLearnMoreModal/usePaymentMethodLearnMoreModal";
import { StepPage } from "../../components/StepPage";
import BankSecurityRow from "../../../components/BankSecurityRow/BankSecurityRow";
import { TextBox } from "../../components/TextBox";
import { useResponsive } from "../../contexts";
import ManagePaymentMethods from "../../../components/ManagePaymentMethods/ManagePaymentMethods";
import { relationshipModel } from "../../../models";
import { useStore } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import { COBStep, getIsAllowedToSIgn, getStepName, isApproveProposalDisabled } from "../ClientOnboarding.utils";
import { ErrorText } from "../../../constants";
import ApproveProposalButton from "../../components/ApproveProposalButton";
import { useCobConfig } from "../CobConfigContext";
export default function ConnectPaymentMethodStep(props) {
  const {
    isMemberClient = false,
    selectedPaymentId,
    disabledReason,
    approveAgreementStatus = null,
    previewStatus,
    onSelectPaymentMethod,
    onDone,
    onBack
  } = props;
  const {
    relationship
  } = useCobConfig();
  const isVendor = useStore(selectors.user.isVendor);
  const userId = useStore(selectors.user.id);
  const isPreview = !!previewStatus;
  const {
    isMobile,
    isDesktop
  } = useResponsive();
  const openLearnMoreModal = usePaymentMethodLearnMoreModal(isDesktop);
  const role = useStore(selectors.user.role);
  const isAllowedToSign = getIsAllowedToSIgn({
    relationship,
    userId,
    role
  });
  const disabled = isApproveProposalDisabled(relationship.isSample || isPreview ? isPreview : !isAllowedToSign, disabledReason, userId, relationship);
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.paymentMethod, relationship),
    disabledReason: disabled ? disabledReason : undefined,
    errorMessage: approveAgreementStatus === 'error' ? ErrorText.UnexpectedErrorTryAgain : '',
    errorTestid: "payment-method-error-msg",
    testid: "connect-payment-method-step",
    primaryBtn: /*#__PURE__*/React.createElement(ApproveProposalButton, {
      onDone: onDone,
      disabled: disabled || approveAgreementStatus === 'loading',
      testid: relationship.isSample || isPreview ? (relationship.isSample ? 'test-agreement-' : '') + 'payment-method-submit-btn' : 'payment-method-submit-btn',
      relationship: relationship,
      isDesktop: isDesktop,
      previewStatus: previewStatus
    }),
    backBtnTestid: (relationship.isSample ? 'test-agreement-' : '') + 'payment-method-back-btn',
    onBackBtnClick: onBack
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(GridItem, null, /*#__PURE__*/React.createElement(TextBox, null, /*#__PURE__*/React.createElement(Typography, null, "Select a payment method to connect. You will only pay what is stated in the agreement.", ' ', /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "payment-method-learnmore-btn",
    onClick: openLearnMoreModal
  }, "Learn more")))), /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(ManagePaymentMethods, {
    isProposal: true,
    vendorId: relationshipModel.vendor(relationship),
    customerId: relationshipModel.customer(relationship),
    showCreditCardFee: !relationshipModel.isVendorCoveringCCFee(relationship),
    isPreview: isPreview,
    isMobile: isMobile,
    isSample: relationshipModel.isSample(relationship),
    isMemberClient: isMemberClient,
    isInviteMemberDisabled: isVendor || relationshipModel.isSample(relationship) || isPreview,
    onSelectPaymentMethod: function (_onSelectPaymentMethod) {
      function onSelectPaymentMethod(_x) {
        return _onSelectPaymentMethod.apply(this, arguments);
      }
      onSelectPaymentMethod.toString = function () {
        return _onSelectPaymentMethod.toString();
      };
      return onSelectPaymentMethod;
    }(pm => {
      onSelectPaymentMethod(pm ? {
        id: pm.id,
        type: pm.type,
        last4: pm.last4,
        fundingSourceId: pm.id
      } : undefined);
    }),
    relationshipId: relationshipModel.id(relationship),
    initialSelectedPaymentMethodId: selectedPaymentId
  })), /*#__PURE__*/React.createElement(GridItem, {
    span: 12
  }, /*#__PURE__*/React.createElement(BankSecurityRow, {
    mobileView: isMobile
  }))));
}